import React from "react"
import classNames from "classnames";

import styles from '../css/SnackBar.module.css';
import Title from "./Title";

export interface Props {
    children?: React.ReactNode,
    show?: boolean,
    isError?: boolean,
    text?: string,
}

export default (props: Props) => {
    const {children, isError, text, show} = props;
    return (
        <div className={classNames(styles.snackBar, {
            [styles.snackBarShow]: show,
            [styles.snackBarError]: isError,
        })}>
            {text ? <Title color={'white'} xs title={text}/> : children}
        </div>
    )
}
